<template>
  <MetricCircle
    :value='score'
    :label='label'
    :icon='icon'
    :name='name'
    :small='small'
  />
</template>

<script>
import User from '@/models/user'
import MetricCircle from '@/components/MetricCircle'

export default {
  name: 'MetricSleepConsistency',
  props: {
    dateFrom: String,
    dateTo: String,
    hideLabel: Boolean,
    hideName: Boolean,
    small: Boolean,
  },
  components: {
    MetricCircle,
  },
  data() {
    return {
      score: undefined,
      label: undefined,
      icon: 'metric_consistency.png',
      name: this.hideName ? undefined : 'Consistency',
    }
  },
  beforeMount() {
    this.loadMetric()
  },
  watch: {
    // TODO: Also watch `dateTo` when implementing date range picker.
    dateFrom() {
      this.loadMetric()
    },
  },
  methods: {
    async loadMetric() {
      if (!this.dateFrom || !this.dateTo) return
      const user = await User.getCurrentUser()
      const consistency = await user.getSleepConsistencyScore(this.dateFrom, this.dateTo)
      this.score = Math.round(consistency.score)
      this.label = this.hideLabel ? undefined : Math.round(consistency.score).toString()
    },
  },
}
</script>